import { faker } from '@faker-js/faker'
import { GetReportsResponse, ReportsItem, ReportType } from '../types'

export const generateReportsResponse: (
    limit: number,
    totalItems: number
) => GetReportsResponse = (limit, totalItems) => {
    const items = Array.from(new Array(limit)).map(() => {
        const options = ['usage', 'payables']
        const position = Math.floor(Math.random() * 2)
        const reportType = options[position]

        const report: ReportsItem = {
            customReportId: `${reportType}-${faker.string.uuid()}`,
            name: `${reportType}: ${faker.number.int().toString()}`,
            owner: {
                userId: faker.string.uuid(),
                name: `${faker.person.firstName()} ${faker.person.lastName()}`,
            },
            type: reportType as ReportType,
            updatedAt: Math.floor(faker.date.recent().getTime()),
        }

        return report
    })

    return {
        items,
        totalItems,
    }
}
